module.exports = __webpack_public_path__ + "static/media/down.a749c26c.svg";